exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-badge{min-width:0;display:flex;align-items:center}.fts-automation-badge .automation-badge__emoji{flex-shrink:0;margin-right:.375rem}.fts-automation-badge .automation-badge__label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.fts-automation-badge .automation-badge__divider{flex-shrink:0;padding:0 .375rem}", ""]);

// exports
